import { Toast, toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import CloseSVG from '@/assets/icons/close.svg';
import { ExportDocIcon } from '@/components/common/export-doc-icon';
import { Button, ButtonVariant } from '@/components/form/button';

import { ConcentrationPercentage, ViabilityPercentage } from '../percentage-cards';

export const AveragePopup = ({
  t,
  conz,
  viab,
  onClose,
  onClickExport,
}: {
  t: Toast;
  conz: number;
  viab: number;
  onClickExport: () => void;
  onClose?: () => void;
}) => {
  const { t: trans } = useTranslation();

  const handleOnClose = () => {
    toast.remove(t.id);
    onClose && onClose();
  };

  return (
    <div
      className={`${
        t.visible ? 'animate-enter' : 'animate-leave'
      } max-w-sm md:max-w-3xl w-full bg-white drop-shadow-2xl shadow-2xl rounded-lg pointer-events-auto`}
    >
      <div className="flex justify-between px-5 pt-5">
        <p className="text-xl font-bold uppercase text-black-light">
          {trans('measurements.average')}
        </p>
        <button onClick={handleOnClose}>
          <img src={CloseSVG} alt="close" />
        </button>
      </div>

      <div className="flex flex-col divide-y">
        <div className="flex justify-between px-5 py-5 md:px-10">
          <ViabilityPercentage viability={viab} />
          <ConcentrationPercentage concentration={conz} />
        </div>

        <div className="flex justify-center px-5 py-10 md:px-10">
          <Button variant={ButtonVariant.Secondary} onClick={onClickExport}>
            <div className="flex items-center gap-2 text-sm">
              <ExportDocIcon color="white" />
              {trans('Export selected measurements as CSV')}
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};
